import template from './productAmount.html';
import './productAmount.scss';
import _ from 'lodash';

class ProductAmountController {
    /*@ngInject*/ 
    constructor($window, $scope, alertService, userService) {
        this.$window = $window;
        this.$scope = $scope;
        this.alertService = alertService;
        this.userService = userService;

        this.$scope.alertDialog = 'Keypad error';
    }

    addToCartOverrideText() {
        const prop = _.find(this.properties, { name: 'addToCartOverrideText' });
        if (!_.isNil(prop)) {
            return prop.value;
        }

        return null;
    }

    overrideButtonClick() {
        if (this.userService.current.ServicePlanInfo.AdcServicePlan === 'VideoOnly') {
            const savApplicable = _.find(this.properties, { name: 'savApplicable' });
            if (!savApplicable || savApplicable.value !== 'True') {
                this.alertService
                    .get(this.$scope.alertDialog)
                    .setType('danger')
                    .setMessage('You cannot add this item to your cart on a Video Only plan.')
                    .open();
                window.scrollTo(0, 0);
                return;
            }
        }

        const url = _.find(this.properties, { name: 'addToCartOverrideUrl' });
        if (!_.isNil(url)) {
            this.$window.location.href = this.$scope.baseUrl + url.value;
        }
    }

    formatLink() {
        return _.replace(this.link, '~/', '');
    }
}

export default {
    template: template,
    bindings: {
        productId: '<',
        link : '<',
        price : '<',
        max: '<',
        productName: '<',
        productSku: '<',
        imageUrl: '<',
        isBuyable: '<',
        properties: '<'
    },
    controller: ProductAmountController
};